import React from 'react'
import { IconButton } from '../../../../shared/components/buttons/icon-button/IconButton'
import { IconEye } from '../../../../shared/components/icons/IconEye'
import { IconEyeOff } from '../../../../shared/components/icons/IconEyeOff'
import { usePostAdvertiserReportsSiteSettingsMutation } from '../../../../app/api'
import { Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'

interface HiddenActionCellProps {
  domain: string
  is_hide: boolean
  project: string
}

export const HiddenActionCell = ({ domain, is_hide, project }: HiddenActionCellProps) => {
  const { t } = useTranslation()
  const [editOrganicSetting] = usePostAdvertiserReportsSiteSettingsMutation()

  return (
    <Tooltip title={is_hide ? t('buttons.unhide') : t('buttons.hide')}>
      <div>
        <IconButton
          size='lg'
          onClick={() => {
            if (!project) return
            editOrganicSetting({
              body: {
                project_id: +project,
                domain,
                is_hide: !is_hide ? 1 : 0,
              },
            })
          }}
        >
          {is_hide ? <IconEye color='#A059FF' /> : <IconEyeOff color='#A059FF' />}
        </IconButton>
      </div>
    </Tooltip>
  )
}
